/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from "react";
import "./dash.css";
import axios from "axios";
import _ from "lodash";
import moment from "moment";
import Select from "react-select";
import {Bar, Pie, Line} from "react-chartjs-2";
import {SERVER} from "./Redux/actions/actionType";
import {connect} from "react-redux";
import {Redirect} from "react-router-dom";
//import {stockData} from "./datas";
const data1 = {
  labels: ["Caraibe", "Magik 9", "Metropole", "Melodie", "Sky"],
  datasets: [
    {
      data: [503, 389, 100, 395, 179],
      backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#a8e4b1", "306d75"],
      hoverBackgroundColor: [
        "#FF6384",
        "#36A2EB",
        "#FFCE56",
        "#a8e4b1",
        "306d75",
      ],
    },
  ],
};
const data = {
  labels: ["January", "February", "March", "April", "May", "June", "July"],
  datasets: [
    {
      label: "My First dataset",
      backgroundColor: "rgba(255,99,132,0.2)",
      borderColor: "rgba(255,99,132,1)",
      borderWidth: 1,
      hoverBackgroundColor: "rgba(255,99,132,0.4)",
      hoverBorderColor: "rgba(255,99,132,1)",
      data: [65, 59, 80, 81, 56, 55, 40],
    },
  ],
};

const data2 = {
  labels: ["January", "February", "March", "April", "May", "June", "July"],
  datasets: [
    {
      label: "My First dataset",
      fill: false,
      lineTension: 0.1,
      backgroundColor: "rgba(75,192,192,0.4)",
      borderColor: "rgba(75,192,192,1)",
      borderCapStyle: "butt",
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: "miter",
      pointBorderColor: "rgba(75,192,192,1)",
      pointBackgroundColor: "#fff",
      pointBorderWidth: 1,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: "rgba(75,192,192,1)",
      pointHoverBorderColor: "rgba(220,220,220,1)",
      pointHoverBorderWidth: 2,
      pointRadius: 1,
      pointHitRadius: 10,
      data: [65, 59, 80, 81, 56, 55, 40],
    },
  ],
};

const options = [
  {value: "compas", label: "Compas"},
  {value: "vodou", label: "Vodou"},
  {value: "rnb", label: "RNB"},
  {value: "afro", label: "Afro"},
  {value: "raggae", label: "Raggae"},
];

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      authors: [],
      artworks: [],
      selected: 0,
      allMusic: [],
      musicsTmp: [],
      groupsByDay: [],
      datas: [],
    };
  }

  changeSelected = (val) => {
    this.setState({selected: val});
  };

  componentDidMount() {
    //console.log(JSON.stringify(daysOfYear));

    let self = this;
    axios
      .get(`${SERVER}/users`)
      .then(function (response) {
        console.log(response.data);
        self.setState({
          authors: response.data,
          loading: false,
        });
      })
      .catch(function (error) {
        console.log(error);
      });

    axios
      .get(`${SERVER}/artworks`)
      .then(function (response) {
        console.log(response.data);
        self.setState({
          artworks: response.data,
          loading: false,
        });
      })
      .catch(function (error) {
        console.log(error);
      });

    axios
      .get(`${SERVER}/stats?_limit=4000`)
      .then(function (response) {
        self.setState({
          datas: response.data,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  render() {
    if (
      this.props.user &&
      (!this.props.user.user || this.props.user.user.role_user !== "admin")
    ) {
      return <Redirect to={"/"} />;
    } else {
      return (
        <div style={{marginTop: 100}}>
          <div className="container-fluid">
            <div className="row navbar-expand-md">
              <nav
                className="col-md-3 col-lg-2 bg-light navbar-collapse collapse sidebar"
                id="sidenav"
                style={{marginTop: 50}}>
                <div className="sidebar-sticky flex-column w-100 mt-1">
                  <ul className="nav flex-column">
                    <li className="nav-item">
                      <a
                        className={`nav-link ${
                          this.state.selected === 0 ? "active" : ""
                        }`}
                        style={{cursor: "pointer"}}
                        onClick={() => this.setState({selected: 0})}>
                        <span></span> Dashboard
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link ${
                          this.state.selected === 1 ? "active" : ""
                        }`}
                        onClick={() => this.setState({selected: 1})}
                        style={{cursor: "pointer"}}>
                        <span data-feather="file"></span> Auteurs
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link ${
                          this.state.selected === 2 ? "active" : ""
                        }`}
                        onClick={() => this.setState({selected: 2})}
                        style={{cursor: "pointer"}}>
                        <span data-feather="file"></span> Oeuvres
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link ${
                          this.state.selected === 3 ? "active" : ""
                        }`}
                        onClick={() => this.setState({selected: 3})}
                        style={{cursor: "pointer"}}>
                        <span data-feather="users"></span> Monitoring
                      </a>
                    </li>
                  </ul>

                  {/* <h6 className="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
                    <span>Saved reports</span>
                    <a
                      className="d-flex align-items-center text-muted"
                      href="#">
                      <span data-feather="plus-circle"></span>
                    </a>
                  </h6> */}

                  {/* <ul className="nav flex-column mb-2">
                    <li className="nav-item">
                      <a className="nav-link" href="#">
                        <span data-feather="file-text"></span> Current month
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#">
                        <span data-feather="file-text"></span> Last quarter
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#">
                        <span data-feather="file-text"></span> Social engagement
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#">
                        <span data-feather="file-text"></span> Year-end sale
                      </a>
                    </li>
                  </ul>
               */}
                </div>
              </nav>

              <main
                role="main"
                className="col-md-9 ml-sm-auto col-lg-10 pt-3 px-4">
                {this.state.selected === 0 ? (
                  <DashView
                    authors={this.state.authors}
                    artworks={this.state.artworks}
                    datas={this.state.datas}
                  />
                ) : this.state.selected === 1 ? (
                  <AuthorView
                    authors={this.state.authors}
                    changeSelected={(v) => this.changeSelected(v)}
                  />
                ) : this.state.selected === 2 ? (
                  <ArtworkView artworks={this.state.artworks} />
                ) : this.state.selected === 3 ? (
                  <ListenView
                    datas={this.state.datas}
                    authors={this.state.authors}
                    artworks={this.state.artworks}
                  />
                ) : null}
              </main>
            </div>
          </div>
        </div>
      );
    }
  }
}

class DashView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      groupsByDay: [],
      groupsByRadio: [],
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.datas.length !== this.props.datas.length) {
      /////////////////////////////////

      var groups = _.groupBy(this.props.datas, function (date) {
        return moment(date.data.metadata.timestamp_utc).startOf("day").format();
      });

      var result = _.map(groups, function (group, day) {
        return {
          day: day,
          times: group,
        };
      });
      var groups2 = _.groupBy(this.props.datas, function (date) {
        return date.data.radio.label;
      });

      var result2 = _.map(groups2, function (group, radio) {
        return {
          radio: radio,
          data: group,
        };
      });

      this.setState({
        groupsByDay: _.orderBy(result, ["day"], ["asc"]),
        groupsByRadio: result2,
      });

      ///////////////////////////////
    }
  }

  componentDidMount() {
    var groups = _.groupBy(this.props.datas, function (date) {
      return moment(date.data.metadata.timestamp_utc).startOf("day").format();
    });

    var result = _.map(groups, function (group, day) {
      return {
        day: day,
        times: group,
      };
    });

    var groups2 = _.groupBy(this.props.datas, function (date) {
      return date.data.radio.label;
    });

    var result2 = _.map(groups2, function (group, radio) {
      return {
        radio: radio,
        data: group,
      };
    });

    this.setState({
      groupsByDay: _.orderBy(result, ["day"], ["asc"]),
      groupsByRadio: result2,
    });
  }

  render() {
    const {authors, artworks} = this.props;
    return (
      <div>
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom">
          <div className="btn-toolbar mb-2 mb-md-0">
            <div className="btn-group mr-2">
              <button
                className="btn btn-sm btn-outline-secondary"
                style={{cursor: "pointer"}}
                onClick={() => alert("ll")}>
                Share
              </button>
              <button className="btn btn-sm btn-outline-secondary">
                Export
              </button>
            </div>
            <button className="btn btn-sm btn-outline-secondary dropdown-toggle">
              <span data-feather="calendar"></span> This week
            </button>
          </div>
        </div>

        <div className="row">
          <div className=" col-lg-3 col-md-6 ">
            <div className="card  btn btn-default">
              <div className="card-body">
                <h5 className="card-title">{this.props.datas.length}</h5>
                <p className="card-text" style={{color: "#000"}}>
                  Musiques Mon.
                </p>
              </div>
            </div>
          </div>
          <div className=" col-lg-3 col-md-6 ">
            <div className="card  btn btn-default">
              <div className="card-body">
                <h5 className="card-title">
                  {authors.filter((f) => f.role_user !== "admin").length}
                </h5>
                <p className="card-text" style={{color: "#000"}}>
                  Auteurs
                </p>
              </div>
            </div>
          </div>
          <div className=" col-lg-3 col-md-6 ">
            <div className="card btn btn-default">
              <div className="card-body">
                <h5 className="card-title">{artworks.length}</h5>
                <p className="card-text" style={{color: "#000"}}>
                  Oeuvres
                </p>
                {/* <a href="#" className="btn btn-primary">
                  Voir la liste
                </a> */}
              </div>
            </div>
          </div>
          <div className=" col-lg-3 col-md-6 ">
            <div className="card btn btn-default">
              <div className="card-body">
                <h5 className="card-title">
                  {authors.filter((f) => f.role_user === "admin").length}
                </h5>
                <p className="card-text" style={{color: "#000"}}>
                  Administrateur
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className=" col-lg-6">
            {this.state.groupsByDay && this.state.groupsByDay.length > 0 ? (
              <Bar
                data={{
                  labels: this.state.groupsByDay.map((i) =>
                    i.day.substring(0, 10)
                  ),
                  datasets: [
                    {
                      label: "Diffusion",
                      backgroundColor: "rgba(255,99,132,0.2)",
                      borderColor: "rgba(255,99,132,1)",
                      borderWidth: 1,
                      hoverBackgroundColor: "rgba(255,99,132,0.4)",
                      hoverBorderColor: "rgba(255,99,132,1)",
                      data: this.state.groupsByDay.map((i) => i.times.length),
                    },
                  ],
                }}
                width={100}
                height={400}
                options={{
                  maintainAspectRatio: false,
                }}
              />
            ) : (
              <Bar
                data={{
                  labels: [],
                  datasets: [
                    {
                      label: "Diffusion",
                      backgroundColor: "rgba(255,99,132,0.2)",
                      borderColor: "rgba(255,99,132,1)",
                      borderWidth: 1,
                      hoverBackgroundColor: "rgba(255,99,132,0.4)",
                      hoverBorderColor: "rgba(255,99,132,1)",
                      data: [],
                    },
                  ],
                }}
                width={100}
                height={400}
                options={{
                  maintainAspectRatio: false,
                }}
              />
            )}
          </div>
          <div className=" col-lg-6">
            <br />
            {this.state.groupsByRadio && this.state.groupsByRadio.length > 0 ? (
              <Pie
                data={{
                  labels: this.state.groupsByRadio.map((i) => i.radio),
                  datasets: [
                    {
                      data: this.state.groupsByRadio.map((i) => i.data.length),
                      backgroundColor: [
                        "#FF6384",
                        "#36A2EB",
                        "#FFCE56",
                        "#a8e4b1",
                        "306d75",
                      ],
                      hoverBackgroundColor: [
                        "#FF6384",
                        "#36A2EB",
                        "#FFCE56",
                        "#a8e4b1",
                        "306d75",
                      ],
                    },
                  ],
                }}
              />
            ) : (
              <Pie
                data={{
                  labels: [""],
                  datasets: [
                    {
                      data: [100],
                      backgroundColor: [
                        "#FF6384",
                        "#36A2EB",
                        "#FFCE56",
                        "#a8e4b1",
                        "306d75",
                      ],
                      hoverBackgroundColor: [
                        "#FF6384",
                        "#36A2EB",
                        "#FFCE56",
                        "#a8e4b1",
                        "306d75",
                      ],
                    },
                  ],
                }}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

class StatsView extends Component {
  render() {
    return (
      <div>
        <div className="row">
          <div className=" col-lg-6">
            <Bar
              data={data}
              width={100}
              height={500}
              options={{
                maintainAspectRatio: false,
              }}
            />
          </div>
          <div className=" col-lg-6">
            <Pie data={data1} />
          </div>

          <Line data={data2} />
        </div>
      </div>
    );
  }
}

class AuthorView extends Component {
  state = {selected: 0};
  render() {
    const {authors} = this.props;
    return (
      <div>
        {this.state.selected == 0 ? (
          <div className="table-responsive">
            <table className="table table-striped table-sm">
              <thead>
                <tr>
                  <th>#</th>
                  <th>FirstName</th>
                  <th>Username</th>
                  <th>Email</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {authors
                  .filter((a) => a.role_user !== "admin")
                  .map((author, index) => {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{author.firstName}</td>
                        <td>{author.lastName}</td>
                        <td>{author.email}</td>

                        <td>
                          <a
                            style={{
                              cursor: "pointer",
                              color: "blue",
                              marginRight: 5,
                            }}
                            onClick={() => {}}>
                            DETAILS
                          </a>
                          {" - "}

                          <a
                            style={{cursor: "pointer", color: "green"}}
                            onClick={() => {}}>
                            VALIDATION
                          </a>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        ) : (
          <StatsView />
        )}
      </div>
    );
  }
}

class ArtworkView extends Component {
  render() {
    const {artworks} = this.props;
    return (
      <div>
        <div className="table-responsive">
          <table className="table table-striped table-sm">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Author</th>
                <th>Type</th>
                <th>Started</th>
                <th>Finished</th>
                <th>Published</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {artworks.map((artwork, index) => {
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{artwork.name}</td>
                    <td>{artwork.users[0].firstName}</td>
                    <td>{artwork.type.value.toUpperCase()}</td>
                    <td>{artwork.date_start}</td>
                    <td>{artwork.date_finised}</td>
                    <td>{artwork.date_publish}</td>
                    <td>
                      <a
                        style={{
                          cursor: "pointer",
                          color: "blue",
                          marginRight: 5,
                        }}>
                        DETAILS
                      </a>
                      {" - "}

                      <a style={{cursor: "pointer", color: "green"}}>
                        VALIDATION
                      </a>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

class ListenView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activePage: 0,
      allMusic: _.chunk(this.props.datas, 50),
      nnPerPage: 50,
      musics: this.props.datas,
      musicsTmp: this.props.datas,

      backupMusic: [],
      author: "",
      title: "",
      radio: "235480",
      loading: false,
    };
  }

  componentDidMount() {
    //this.setStats();
    let self = this;

    //let a = 1;
    //       self.setState({
    //         musics: stockData,
    //         musicsTmp: stockData,
    //         loading: false,
    //       });
    // var refreshIntervalId = setInterval(() => {
    //   axios
    //     .get(`${SERVER}/stats?_start=${a}&_limit=1000`)
    //     .then(function (response) {
    //       console.log(response);

    //       if (response.data.length < 50) {
    //         clearInterval(refreshIntervalId);
    //       }
    //       self.setState({
    //         musics: _.concat(self.state.musics, response.data),
    //         musicsTmp: _.concat(self.state.musicsTmp, response.data),
    //         loading: false,
    //       });
    //     })
    //     .catch(function (error) {
    //       console.log(error);
    //     });
    //   a = a + 1000;
    // }, 5000);
  }

  listen = (radio, date, author, title) => {
    let self = this;

    let date_ =
      date.getFullYear() +
      "" +
      (date.getMonth() < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) +
      "" +
      (date.getDate() < 10 ? "0" + date.getDate() : date.getDate());

    axios
      .get(
        `https://cors-anywhere.herokuapp.com/https://api.acrcloud.com/v1/acrcloud-monitor-streams/${radio.value}/results?access_key=a54f67369a4ce05e49c8af7263f1831d&date=${date_}`
      )
      .then(function (response) {
        var other = _.concat(
          self.state.backupMusic,
          self.filtre(
            response.data.map((a) => {
              a.radio = radio;

              return a;
            }),
            author,
            title
          )
        );
        self.setState({backupMusic: other}, () =>
          console.log(self.state.backupMusic.length)
        );
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  filtre = (arr, artist, title) => {
    return arr
      ? arr
          .filter((d) =>
            JSON.stringify(d.metadata.music[0].title)
              .toLowerCase()
              .includes(title.toLowerCase())
          )
          .filter((d) =>
            JSON.stringify(d.metadata.music[0].artists)
              .toLowerCase()
              .includes(artist.toLowerCase())
          )
      : [];
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.musics.length !== this.state.musics.length) {
      console.log("new data...");
      this.setState({
        allMusic: _.chunk(this.state.musics, this.state.nnPerPage),
      });
    }
  }

  setStats = () => {
    let radios = [
      {value: "280319", label: "Trace FM Haiti"},
      {value: "235480", label: "Magik9 100.9 FM"},
    ];
    let art = [
      //"Rayy",
      //"Paska",
      //"Steves",
      //"roody roodboy",
      //"kanis",
      //"tonymix",
      //"izolan",
      //"fantom",
      //"baky",
      //"Perry",
    ];
    var now = new Date();
    localStorage.setItem("lastupdate", now.toDateString());

    for (let a = 0; a < art.length; a++) {
      for (let r = 0; r < radios.length; r++) {
        const rad = radios[r];

        for (
          var d = new Date(2020, 6, 4);
          d <= now;
          d.setDate(d.getDate() + 1)
        ) {
          this.listen(rad, new Date(d), art[a], "");
        }
      }
    }
  };

  setAll = () => {
    for (let i = 0; i < this.state.backupMusic.length; i++) {
      //let music = this.state.backupMusic[i].metadata.music[0];
      // let obj = {
      //   artists: music.artists,
      //   album: music.album,
      //   label: music.label,
      //   title: music.title,
      //   sourceId: "280319",
      //   sourceName: "tracehaiti",
      //   uniqueId:
      //     this.state.musics[i].metadata.timestamp_utc + this.state.radio,
      // };
      axios
        .post(`${SERVER}/stats`, {data: this.state.backupMusic[i]})
        .then(function (response) {
          console.log(response.data);
        })
        .catch(function (error) {
          console.log(error);
        });
      //console.log(JSON.stringify(music, null, 2));
    }
  };

  render() {
    const {allMusic} = this.state;
    return (
      <div>
        <div className="row">
          <div className="col-lg-3">
            <Select
              style={{width: 200}}
              options={this.props.artworks.map((a) => {
                return {value: a.name, label: a.name};
              })}
              onChange={(input) => {
                let results = this.state.musicsTmp.filter((d) =>
                  JSON.stringify(d.data)
                    .toLowerCase()
                    .includes(input.value.toLowerCase())
                );

                this.setState({musics: results});
              }}
            />
            <br />
          </div>
          <div className="col-lg-3">
            <Select
              style={{width: 200}}
              options={this.props.authors
                .filter((a) => a.role_user !== "admin")
                .map((a) => {
                  return {value: a.username, label: a.username};
                })}
              onChange={(input) => {
                console.log(input);
                let results = this.state.musicsTmp.filter((d) =>
                  JSON.stringify(d.data)
                    .toLowerCase()
                    .includes(input.value.toLowerCase())
                );

                this.setState({musics: results});
              }}
            />
            <br />
          </div>
          <div className="col-lg-3">
            <Select
              style={{width: 200}}
              options={[
                {value: "280319", label: "Trace FM Haiti"},
                {value: "235480", label: "Magik9 100.9 FM"},
              ]}
              onChange={(input) => {
                this.setState({musics: [], activePage: 0});
                let results = this.state.musicsTmp.filter((d) =>
                  JSON.stringify(d.data.radio)
                    .toLowerCase()
                    .includes(input.value.toLowerCase())
                );
                this.setState({musics: results});
              }}
            />
          </div>
          <div className="col-lg-3">
            <label className="col-lg-12">
              <input
                onChange={(input) => {
                  this.setState({musics: [], activePage: 0});
                  let results = this.state.musicsTmp.filter((d) =>
                    JSON.stringify(d.data)
                      .toLowerCase()
                      .includes(input.target.value.toLowerCase())
                  );
                  this.setState({musics: results});
                }}
                type="text"
                className="form-control"
                placeholder="Recherche....."
                required
                style={{height: 50}}
              />
            </label>

            <br />
          </div>
        </div>

        <div className="table-responsive">
          {/* <button onClick={() => this.setAll()}>Set all</button> */}

          <table className="table table-bordered table-dark">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Date</th>
                <th scope="col">Titre</th>
                {/* <th scope="col">Album</th> */}
                <th scope="col">Artiste</th>
                <th scope="col" style={{width: 150}}>
                  Radio
                </th>
              </tr>
            </thead>

            {allMusic.length > 0 ? (
              <tbody>
                {allMusic[this.state.activePage].map((item, index) => {
                  let music = item.data.metadata.music[0];
                  return (
                    <tr key={index}>
                      <th scope="row">
                        {(this.state.activePage > 0
                          ? this.state.activePage * 50
                          : 0) +
                          index +
                          1}
                      </th>
                      <th style={{width: 200}}>
                        {item.data.metadata.timestamp_utc}
                      </th>
                      <td>{music.title}</td>
                      {/* <td>{music.album.name}</td> */}
                      <td>{music.artists[0].name}</td>
                      <td>{item.data.radio.label}</td>
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <tbody>
                <tr style={{height: 400}}></tr>
              </tbody>
            )}
          </table>
          {this.state.loading === true ? (
            <center>
              <h6>Loading....</h6>
            </center>
          ) : null}

          {allMusic.length > 0 ? (
            <nav aria-label="Page navigation example">
              <ul class="pagination">
                <li class="page-item">
                  <a
                    onClick={() =>
                      this.setState({
                        activePage:
                          this.state.activePage > 1
                            ? this.state.activePage - 1
                            : 0,
                      })
                    }
                    class="page-link"
                    aria-label="Previous"
                    style={{cursor: "pointer"}}>
                    <span aria-hidden="true">&laquo;</span>
                  </a>
                </li>
                {this.state.allMusic.map((i, index) => {
                  return (
                    <li
                      class={
                        this.state.activePage === index
                          ? "page-item active"
                          : "page-item"
                      }
                      style={{cursor: "pointer"}}
                      onClick={() => this.setState({activePage: index})}>
                      <a class="page-link">{index + 1}</a>
                    </li>
                  );
                })}

                <li
                  class="page-item"
                  style={{cursor: "pointer"}}
                  onClick={() =>
                    this.setState({
                      activePage:
                        this.state.activePage < allMusic.length - 1
                          ? this.state.activePage + 1
                          : allMusic.length - 1,
                    })
                  }>
                  <a class="page-link" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                  </a>
                </li>
              </ul>
            </nav>
          ) : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
    stats: state.user.stats,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
